import { Component, OnInit, Output, Input, ViewChild } from '@angular/core';
import { NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { MatSort } from '@angular/material/sort';
import { finalize, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { RangeDateComponent } from '../dialogs/range-date/range-date.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { MonthpickerComponent } from '../dialogs/monthpicker/monthpicker.component';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-reportages',
  templateUrl: './reportages.component.html',
  styleUrls: ['./reportages.component.sass']
})
export class ReportagesComponent implements OnInit {

  public yearperiodActive: boolean;

  reportagesListSubs: Subscription;
  reportages: any;
  url: string;
  reportagesList: Reportage[];
  reportageForm: FormGroup;
  showPrimarySpinner: boolean = false;
  isList: boolean = true;
  isNew: boolean = false;
  catalogsListSubs: Subscription;
  catalogs: any;
  yearperiodsListSubs: Subscription;
  yearperiods: any;
  filteredUsersListSubs: Subscription;
  filteredUsers: any;
  templatesListSubs: Subscription;
  templates_new_photo: any;
  templates_reminder: any;
  templates_order: any;
  // name = 'Angular ' + VERSION.major;
  // elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  value: string;
  modification_date: string;
  creation_date: string;
  reportage_name: string;
  pageSize: number = 100;
  pageIndex: number = 0;
  selectedFiles: File;
  type_accept: string;
  role: any;
  pageEvent: PageEvent;
  index: number;
  displayedColumns: string[] = ['select', 'name', 'yearperiod', 'actions'];
  // dataSource = new MatTableDataSource<any>();
  dataSource: TableData = null;
  tableDataItems: any;
  message: any

  loadingCheckSendNotifications: boolean = false

  public selection = new SelectionModel<any>(true, [])

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;
  @ViewChild('tabGroup') tabGroup;

  // TODO Substitute for a progress bar
  showReportageprogressSpinner: boolean = false;

  // Currently only shown once table is already rendered.
  showReportageProgressBar: boolean = false;

  notificationType: any = "new_photo"


  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public firebaseStorageService: FirebaseStorageService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private snackbar: MatSnackBar
  ) { }


  public getReportages() {
    var params = { 'catalogue': '', 'theme': '', 'search': '' }
    this.reportagesListSubs = this.dataService
      .getReportages(params)
      .subscribe(res => {
        this.reportages = res;
        // ;
        //           this.usersList = res;
      },
        console.error
      );
  }

  public getCatalogs() {
    this.catalogsListSubs = this.dataService
      .getCatalogs()
      .subscribe(res => {
        this.catalogs = res;
        // ;
        //           this.usersList = res;
      },
        console.error
      );
  }

  public getYearperiods() {
    this.yearperiodsListSubs = this.dataService
      .getYearperiods()
      .subscribe(res => {
        this.yearperiods = res;
        // ;
        //           this.usersList = res;
      },
        console.error
      );
  }

  public getFilteredUsers(role: string) {
    var params = {};
    params['page'] = 1
    params['size'] = 5
    params['search'] = '';
    params['role'] = role;
    this.filteredUsersListSubs = this.dataService
      .getUsers(params)
      .subscribe(res => {
        this.filteredUsers = res;
        this.filteredUsers = [{ 'id': null, 'name': "" }].concat(this.filteredUsers)

      },
        console.error
      );
  }

  public getTemplates() {

    this.templatesListSubs = this.dataService
      .getTemplates()
      .subscribe(res => {
        let new_photo = [];
        let family = [];
        let order = [];
        for (let template in res) {

          if (res[template]['type'] == 'new_photo') {
            new_photo.push({ 'id': res[template]['id'], 'name': res[template]['name'] })
          }
          else if (res[template]['type'] == 'reminder') {
            family.push({ 'id': res[template]['id'], 'name': res[template]['name'] })
          }
          else if (res[template]['type'] == 'order') {
            order.push({ 'id': res[template]['id'], 'name': res[template]['name'] })
          }
          this.templates_new_photo = new_photo;
          this.templates_reminder = family;
          this.templates_order = order;
        }

      },
        console.error
      );
  }

  // ngAfterViewInit() {
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.paginator = this.paginator;
  // }


  ngOnInit(): void {
    this.dataService.getRole().subscribe(res => {
      this.role = res
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/reportages']);
      }

    });
    this.type_accept = '.jpeg, .png, .jpg';

    this.getFilteredUsers('reportage')
    this.getTemplates()
    this.getCatalogs()
    this.getYearperiods()

    this.reportageForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
      // users: new FormControl(null, Validators.required),
      // email: new FormControl('', Validators.required),
      // tpv_payment: new FormControl(true, Validators.required),
      language: new FormControl('es', Validators.required),
      template_new_photo: new FormControl('', Validators.required),
      template_reminder: new FormControl('', Validators.required),
      template_order: new FormControl('', Validators.required),
      yearperiods: new FormControl('', Validators.required),
      catalogs: new FormControl('', Validators.required),
      reportage_image: new FormControl(''),
      no_order: new FormControl(true),
      no_order_txt: new FormControl('Actualmente no hay productos disponibles para reservar/comprar'),
      no_order_txt_cat: new FormControl('Actualment no hi ha productes disponibles per reservar/comprar'),
      no_order_txt_en: new FormControl('There are currently no products available to reserve/buy'),
      lab_reportage_id: new FormControl('', Validators.required),
      notification: new FormControl(true),
      notification_txt: new FormControl(''),
      notification_txt_cat: new FormControl(''),
      notification_txt_en: new FormControl(''),

    });


    this.route.params.subscribe(params => {

      if (params.id) {

        
        this.isList = false;
        if (params.id != 'new') {
          

          this.isNew = false;
          this.reportagesListSubs = this.dataService
            .getReportage(params.id) //cambiar por id en el html
            .subscribe(res => {
              this.reportages = res;

              this.yearperiodActive = this.reportages.activated === false ? false : true
              
              if(params.action == 'duplicate'){
              }
              else{
                this.reportageForm.controls["id"].setValue(this.reportages.id);
                this.reportageForm.controls["lab_reportage_id"].setValue(this.reportages.lab_reportage_id);
                this.reportageForm.controls["name"].setValue(this.reportages.name);
              }
              
              // if (this.reportages.user != null){
              //   this.reportageForm.controls["users"].setValue(this.reportages.user._flat_path[1].toString());
              // }
              // else{
              //   this.reportageForm.controls["users"].setValue(null)
              // }
              // this.reportageForm.controls["email"].setValue(this.reportages.email);
              // this.reportageForm.controls["tpv_payment"].setValue(this.reportages.tpv_payment);
              this.reportageForm.controls["language"].setValue(this.reportages.language);
              this.reportageForm.controls["template_new_photo"].setValue(this.reportages.template_new_photo._flat_path[1].toString());
              this.reportageForm.controls["template_reminder"].setValue(this.reportages.template_reminder._flat_path[1].toString());
              this.reportageForm.controls["template_order"].setValue(this.reportages.template_order._flat_path[1].toString());
              this.reportageForm.controls["yearperiods"].setValue(this.reportages.yearperiod._flat_path[1].toString());
              this.reportageForm.controls["catalogs"].setValue(this.reportages.catalogue._flat_path[1].toString());
              this.reportageForm.controls["reportage_image"].setValue(this.reportages.reportage_image);
              this.reportageForm.controls["no_order"].setValue(this.reportages.no_order);
              this.yearperiodActive ? '' : this.reportageForm.controls["no_order"].disable();
              this.reportageForm.controls["no_order_txt"].setValue(this.reportages.no_order_txt);
              this.reportageForm.controls["no_order_txt_en"].setValue(this.reportages.no_order_txt_en);
              this.reportageForm.controls["no_order_txt_cat"].setValue(this.reportages.no_order_txt_cat);
              this.reportageForm.controls["notification_txt"].setValue(this.reportages.notification_txt);
              this.reportageForm.controls["notification_txt_en"].setValue(this.reportages.notification_txt_en);
              this.reportageForm.controls["notification_txt_cat"].setValue(this.reportages.notification_txt_cat);

              // this.value = `${environment.WEB_URL}/public/` + this.reportages.id;
              this.modification_date = this.reportages.modification_date;
              this.creation_date = this.reportages.creation_date;
              this.reportage_name = this.reportages.name;

            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }


      }
      else {
        this.isList = true;
        this.initDataSource();

      }
    });
  }

  checkReportageNotifications(type: any) {
    this.showPrimarySpinner = true;

    let params = {}

    params['template_id'] = type
    params['type'] = 'reportage'


    let title = this.translate.get('alerts.atention')

    this.message = this.translate.get('alerts.checkNotifications')

    let ok_txt = this.translate.get('buttons.ok')

    console.log(params)
    this.selection.selected.forEach(element => {
      console.log(element)

      params['reportage_id'] = element.id
      this.dataService.checkSendNotifications(params).subscribe(res => {
        // console.log(res)
        params['users_list'] = JSON.stringify(res.user_list);
        // console.log(params)
        this.showPrimarySpinner = false;
        this.message = this.message.replace('{{modify}}', res.num_emails)
  
  
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            message: this.message,
            title: title,
            ok_txt: ok_txt,
          }
        }).afterClosed().subscribe(res2 => {
  
          if (res2 === true) {
            this.showPrimarySpinner = true;
            // console.log(params)
            this.dataService.sendNotifications(params).subscribe(res3 => {
              if (res3.status == 'ok') {
                this.translate.get('alerts.sendNotifications_ok').subscribe(res4 => {
                  this.showPrimarySpinner = false;
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
                })
              }
              else {
                this.translate.get('alerts.send_notifications_error').subscribe(res4 => {
                  this.showPrimarySpinner = false;
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
                })
              }
            })
          }
        })
      })
    });
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource['items']);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource['items'].length;
    return numSelected === numRows;
  }

  getMonth(){
    // We throw a confirm action popup
    let dialogRef = this.dialog.open(MonthpickerComponent, {

   }).afterClosed().subscribe(res => {
     if (res) {
       this.translate.get('alerts.process_background').subscribe((text: string) => {
         this.snackbar.openFromComponent(CustomPopupComponent, { data: text, duration: 4000 })
       })
       this.dataService.sendInvoiceZip(res).subscribe(response => {
         if (response.status == 'success'){
           this.translate.get('alerts.invoices_zip_send_ok').subscribe((text2: string) => {
             this.snackbar.openFromComponent(CustomPopupComponent, { data: text2, duration: 4000 })
           })
         }
         else if(response.msg && response.msg.includes('email')) {
           this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.email_format'), duration: 4000, panelClass: "error-snackbar"  })
         }
         else{
           this.translate.get('alerts.invoices_not_found').subscribe((text2: string) => {
             this.snackbar.openFromComponent(CustomPopupComponent, { data: text2, duration: 4000, panelClass: "error-snackbar"  })
           })
         }
       })

     }
   })
 }

 switchActiveOrder(reportage_id: any) {
  let params = {}
  params['id'] = reportage_id

  this.dataService.updateReportageActiveOrders(params).subscribe(res => {
    
    if(res == '' || res == undefined)
    {
      let data = {}
      data['page'] = this.paginator.pageIndex+1
      data['pageSize'] = this.paginator.pageSize
      localStorage.setItem('reportages', JSON.stringify(data))
      this.initDataSource()
    }
    else
    {
      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.no_permissions'), duration: 4000, panelClass: "error-snackbar" })
    }
  })
 }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params.tabid) {
        this.changeIndexSelected(params.tabid)
      }
    })
  }


  goTo(reportageID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    localStorage.setItem('reportages', JSON.stringify(data))
    this.router.navigateByUrl(`reportage/${reportageID}`);
  }

  duplicate_reportage(reportageID: string) {
    this.router.navigateByUrl(`reportage/${reportageID}/duplicate`);
  }

  changeIndexSelected(index){
    this.tabGroup.selectedIndex = Number(index);
  }

  sendNotifications(reportageID: string) {
    // this.router.navigate([]).then(result => { window.open(`public/${reportageID}`, '_blank'); });
    this.router.navigateByUrl(`send-notifications/reportage/${reportageID}`);
    // alert("in construction");
  }
  uploadReportageRelationships(reportageID: string) {
    // this.router.navigate([]).then(result => { window.open(`public/${reportageID}`, '_blank'); });
    this.router.navigateByUrl(`upload-reportage-relationships/${reportageID}`);
    // alert("in construction");
  }
  uploadImages(reportageID: string) {
    // this.router.navigate([]).then(result => { window.open(`public/${reportageID}`, '_blank'); });
    this.router.navigateByUrl(`upload-reportage-images/${reportageID}`);
    // alert("in construction");
  }


  getReportageReport(reportageID: string){
    this.dataService.getReportageReport(reportageID).subscribe(response => {
      if (response.status == 'success'){
        this.translate.get('alerts.report_send').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
        })
      }
      else if(response.msg && response.msg.includes('email')) {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.email_format'), duration: 4000, panelClass: "error-snackbar"  })
      }
    })
  }

  getReportageOrderManagementReport(reportageID: string){
    this.dataService.getReportageOrderManagementReport(reportageID).subscribe(response => {
      if (response.status == 'success'){
        this.translate.get('alerts.report_send').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
        })
      }
    })
  }

  getMakneticReport(reportageID: string, type: string){
    this.dataService.getMakneticReport(reportageID, type, '').subscribe(response => {
      if (response.status == 'success'){
        this.translate.get('alerts.report_send').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
        })
      }
    })
  }

  getRangeDate(){
     // We throw a confirm action popup
     let dialogRef = this.dialog.open(RangeDateComponent, {

    }).afterClosed().subscribe(res => {

      if (res) {
        this.dataService.getAgencyReport(res).subscribe(response => {
          if (response.status == 'success'){
            this.translate.get('alerts.report_send').subscribe((res: string) => {
              this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
            })
          }
          else if(response.msg.includes('empty') || response.msg.includes('Empty')) {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.no_data_found'), duration: 4000, panelClass: "error-snackbar" })
          }
        })

      }


    })
  }

  sendToFtp(reportageID: string) {
    // We first check if the reportage has the deactivated orders
    this.dataService.checkDeactivateOrders(reportageID, 'reportage').subscribe(response => {
      if (response.status == "ok") {
        let popup_content = {}

        this.translate.get('alerts.atention').subscribe(res => {
          popup_content['title'] = res;
        })

        this.translate.get('alerts.confirm_send_to_ftp').subscribe(res => {
          popup_content['message'] = res;
        })

        this.translate.get('buttons.ok').subscribe(res => {
          popup_content['ok_txt'] = res;
        })
        // We throw a confirm action popup
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: popup_content['title'],
            message: popup_content['message'],
            ok_txt: popup_content['ok_txt']
          }
        }).beforeClosed().subscribe(res => {

          if (res) {
            // this.showPrimarySpinner = true
            // Call backend to change param of deleted to "true"
            this.translate.get('alerts.process_background').subscribe(r => {
              alert(r);
            })
            this.dataService.sendReportageToFtp(reportageID).subscribe(data => {
              // If succesfull
              // this.showPrimarySpinner = false;
              if (data.status == "success") {
                // this.translate.get('alerts.process_background').subscribe(r => {
                //   alert(r);
                // })

              }
              else if (data.status == "empty") {
                this.translate.get('alerts.no_orders_found').subscribe(r => {
                  alert(r);
                })
              }

            },err => console.log(err))
          }
        })

      }
      else {
        this.translate.get('alerts.deactivate_reportage_orders_required').subscribe(r => {
          alert(r);
        })
      }
    })
  }

  sendToLab(reportageID: string) {
    // We first check if the reportage has the deactivated orders
    this.dataService.checkDeactivateOrders(reportageID, 'reportage').subscribe(response => {
      if (response.status == "ok") {
        let popup_content = {}

        this.translate.get('alerts.atention').subscribe(res => {
          popup_content['title'] = res;
        })

        this.translate.get('alerts.confirm_send_to_lab').subscribe(res => {
          popup_content['message'] = res;
        })

        this.translate.get('buttons.ok').subscribe(res => {
          popup_content['ok_txt'] = res;
        })
        // We throw a confirm action popup
        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            title: popup_content['title'],
            message: popup_content['message'],
            ok_txt: popup_content['ok_txt']
          }
        }).beforeClosed().subscribe(res => {

          if (res) {
            // this.showPrimarySpinner = true
            // Call backend to change param of deleted to "true"
            this.translate.get('alerts.process_background').subscribe(r => {
              alert(r);
            })
            this.dataService.sendReportageToLab(reportageID).subscribe(data => {
              // If succesfull
              // this.showPrimarySpinner = false;
              if (data.status == "success") {
                // this.translate.get('alerts.process_background').subscribe(r => {
                //   alert(r);
                // })

              }
              else if (data.status == "empty") {
                this.translate.get('alerts.no_orders_found').subscribe(r => {
                  alert(r);
                })
              }

            },err => console.log(err))


          }


        })

      }
      else {
        this.translate.get('alerts.deactivate_reportage_orders_required').subscribe(r => {
          alert(r);
        })
      }
    })





  }

  newReportage() {
    this.router.navigateByUrl(`reportage/new`);
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }


  saveReportage() {
    var params = {};
    params['id'] = this.reportageForm.controls["id"].value;
    params['name'] = this.reportageForm.controls["name"].value;
    // params['user_id'] = this.reportageForm.controls["users"].value;
    // params['email'] = this.reportageForm.controls["email"].value;
    // params['tpv_payment'] = this.reportageForm.controls["tpv_payment"].value;
    params['activated'] = true;
    params['tpv_payment'] = true;
    params['language'] = this.reportageForm.controls["language"].value;
    params['template_new_photo'] = this.reportageForm.controls["template_new_photo"].value;
    params['template_reminder'] = this.reportageForm.controls["template_reminder"].value;
    params['template_order'] = this.reportageForm.controls["template_order"].value;
    params['yearperiod_id'] = this.reportageForm.controls["yearperiods"].value;
    params['catalogue_id'] = this.reportageForm.controls["catalogs"].value;
    params['no_order'] = this.reportageForm.controls["no_order"].value;
    params['no_order_txt'] = this.reportageForm.controls["no_order_txt"].value;
    params['no_order_txt_en'] = this.reportageForm.controls["no_order_txt_en"].value;
    params['no_order_txt_cat'] = this.reportageForm.controls["no_order_txt_cat"].value;
    params['lab_reportage_id'] = this.reportageForm.controls["lab_reportage_id"].value;
    params['notification_txt'] = this.reportageForm.controls["notification_txt"].value;
    params['notification_txt_en'] = this.reportageForm.controls["notification_txt_en"].value;
    params['notification_txt_cat'] = this.reportageForm.controls["notification_txt_cat"].value;

    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        
      })
      return false;
    }
    if ((params['lab_reportage_id'].length != 3)) {
      this.translate.get('alerts.lab_reportage_id_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        
      })
      return false;
    }
    if (this.selectedFiles) {
      const filePath = 'reportages/' + params['name'];
      const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
      const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, this.selectedFiles[0]);
      uploadTask.snapshotChanges().pipe(
        finalize(() => {
          params['url'] = filePath

          this.dataService.saveReportage(params).subscribe(data => {
            
            if (data == '') {
              this.router.navigateByUrl(`reportages`);
            }
            else if (data == 'exists'){
              this.translate.get('alerts.reportage_exists').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
              })
            }
            else {
              this.translate.get('alerts.save_reportage_error').subscribe((res: string) => {
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
              })
            }
            this.showReportageProgressBar = false
          })

        })
      ).subscribe();
    }
    else {
      params['url'] = this.reportages.url? this.reportages.url : ''
      this.dataService.saveReportage(params).subscribe(data => {
        if (data == '') {
          this.router.navigateByUrl(`reportages`);
        }
        else if (data == 'exists'){
          this.translate.get('alerts.reportage_exists').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
        else {
          this.translate.get('alerts.save_reportage_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    }
  }
  applyFilter(event: Event) {
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();

    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }
  }

  sendMassiveNotifications() {
    this.loadingCheckSendNotifications = true
    
    let threads = this.selection.selected.length

    let dataParams: any[] = []

    let finalMessage = ""

    let totalMessages: number = 0

    for(let i = 0; i < this.selection.selected.length; i++) {

      let params = {}

      params['reportage_id'] = this.selection.selected[i].id

      if(this.notificationType == "new_photo")
      {
        params['template_id'] = this.selection.selected[i].template_new_photo._flat_path[1]
      }
      else
      {
        params['template_id'] = this.selection.selected[i].template_reminder._flat_path[1]
      }
      params['type'] = 'reportage'

      dataParams.push(params)

      let sub = this.dataService.checkSendNotifications(params).subscribe(res => {

        threads -= 1
        
        params['users_list'] = JSON.stringify(res.user_list);

        let message: any = this.translate.instant('alerts.checkNotifications').split('.')[0]
        
        this.showPrimarySpinner = false;
        message = this.selection.selected[i].name +": "+ message.replace('{{modify}}', res.num_emails)

        totalMessages += Number(res.num_emails)

        finalMessage += message+`
        \n`
        sub.unsubscribe()

        if(threads<= 0)
        {
          this.loadingCheckSendNotifications = false

          let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
            data: {
              message: finalMessage,
              total_messages: totalMessages,
              title: this.translate.instant('alerts.atention'),
              ok_txt: this.translate.instant('buttons.ok')
            }
          }).afterClosed().subscribe(res2 => {
    
            if (res2 === true) {
              this.showPrimarySpinner = true;
              
              for(let x = 0; x < dataParams.length; x++) {
                this.dataService.sendNotifications(dataParams[x]).subscribe(res3 => {
                  if (res3.status == 'ok') {
                    this.translate.get('alerts.sendNotifications_ok').subscribe(res4 => {
                      this.showPrimarySpinner = false;
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
                    })
                  }
                  else {
                    this.translate.get('alerts.send_notifications_error').subscribe(res4 => {
                      this.showPrimarySpinner = false;
                      this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
                    })
                  }
                })
              }
            }

            dialogRef.unsubscribe()
          })
        }
      }, err => this.loadingCheckSendNotifications = false)
    }
  }

  changeFilter(event, input) {

    this.showReportageProgressBar = true

    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;
            
    this.pageIndex = 0
    this.paginator.pageIndex = 0
    
    this.dataService.getReportages(params).pipe(
      map((reportageData: TableData) => this.dataSource = reportageData)
    ).subscribe(() => this.showReportageProgressBar = false)
  }

  initDataSource() {

    this.showReportageprogressSpinner = true;

    var params = {};

    params['page'] = 1
    params['size'] = this.pageSize
    params['search'] = '';

    if(localStorage.getItem('reportages'))
    {
      let data = JSON.parse(localStorage.getItem('reportages'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1

      params['page'] = this.pageIndex+1
      params['size'] = this.pageSize
    }

    
    this.dataService.getReportages(params).pipe(
      // TODO Review change of type of shool data.
      // Was previously "TableData" but for some reason the data received has different model.
      map((reportageData: TableData) => {
        this.dataSource = reportageData
      })
    ).subscribe(() => this.showReportageprogressSpinner = false)

  }

  onPaginateChange(event: PageEvent) {

    this.showReportageProgressBar = true

    this.pageSize = event.pageSize
    var params = {};

    params['page'] = event.pageIndex + 1
    params['size'] = this.pageSize
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;

    
    this.dataService.getReportages(params).pipe(
      map((reportageData: TableData) => this.dataSource = reportageData)
    ).subscribe(() => this.showReportageProgressBar = false)

    // let page = event.pageIndex;
    // let size = event.pageSize;

    // page = page + 1;

    // var params={};
    // params['catalogue'] = this.filterForm.controls["catalogue"].value;
    // params['theme'] = this.filterForm.controls["theme"].value;
    // params['page'] = page;
    // params['size'] = size;
    // this.dataService.getReportages(params).subscribe(reportages => {
    //   this.reportages = reportages;
    //   this.dataSource.data = this.reportages;

    //   // this.dataSource.filter = '';


    // });
  }
  addStage() {
    alert("In construction...")
  }

  replicateReportage() {
    alert("In construction...")
  }


  public onYearperiodChange(yearperiod: any){
    let selected;
    this.yearperiods.forEach(yp => {
      if(yp.id==yearperiod.value){
        selected = yp
      }
    });
    this.yearperiodActive = selected.activated
    if (selected.activated === false) {
      this.reportageForm.controls["no_order"].disable()
      this.reportageForm.controls["no_order"].setValue(true)
    } else {
      this.reportageForm.controls["no_order"].enable();
    }

  }


}


export class Reportage {
  constructor(
    public name: string
  ) { }
}


export interface TableData {
  reportages: Reportage[];
  meta: {
    totalReportages: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  },
  links: {
    first: string;
    previous: string;
    next: string;
    last: string;
  }
}
